import React, { Component } from "react";
import CssClasses from "./EventGroupItem.css";
import BetTypeButton from "../UI/BetTypeButton/BetTypeButton";
import OddButton from "../UI/OddButton/OddButton";
import SiteIcons from "../../assets/fonts/site_icons/style.css";
import { connect } from "react-redux";
import * as StoreActions from "../../ReduxStore/Actions/ActionIndex";
import Auxx from "../../HOCs/AUXX/Auxx";
import { ConvertEmmettSportIDToBetRadarID } from "../../HOCs/Helpers/SportConverter";
import { reverseArray } from "../../HOCs/Helpers/Utilities";

import allSportsIcon from "../../assets/images/icons/icon_all_sports.png";
import basketballIcon from "../../assets/images/icons/icon_basketball.png";
import soccerIcon from "../../assets/images/icons/icon_soccer.png";
import tennisIcon from "../../assets/images/icons/icon_tennis.png";
import volleyballIcon from "../../assets/images/icons/icon_volleyball.png";
import liwIcon from "../../assets/images/icons/icon_liw.png";
import futsalIcon from "../../assets/images/icons/icon_futsal.png";
import handballIcon from "../../assets/images/icons/icon_handball.png";
import baseballIcon from "../../assets/images/icons/icon_baseball.png";
import hockeyIcon from "../../assets/images/icons/icon_hockey.png";
import badmintonIcon from "../../assets/images/icons/icon_badminton.png";
import rugbyIcon from "../../assets/images/icons/icon_rugby.png";
import footballIcon from "../../assets/images/icons/icon_football.png";
import table_tennisIcon from "../../assets/images/icons/icon_table_tennis.png";
import beach_volleyballIcon from "../../assets/images/icons/icon_beach_volleyball.png";
import bowlsIcon from "../../assets/images/icons/icon_bowls.png";
import dartsIcon from "../../assets/images/icons/icon_darts.png";
import snookerIcon from "../../assets/images/icons/icon_snooker.png";
import cricketIcon from "../../assets/images/icons/icon_cricket.png";
import specialIcon from "../../assets/images/icons/icon_special.png";

import beepHigh from "../../assets/sounds/beep_high.mp3";

import * as MostPlayedOptionIDs from "../../HOCs/Constants/MostPlayedOptionID";
import * as BetRadarSportIDs from "../../HOCs/Constants/BetRadarSportIDs";
import * as SortTypes from "../../HOCs/Constants/SortTypes";

import {
  GetPairsForBetType,
  GetBetDetails,
  GetTicketPairs
} from "../../Communication/PrematchInfoServicesHandler";
import { ConvertLanguageCodeToJezikID } from "../../HOCs/Helpers/LanguageConverter";

let moment = require("moment");
require("moment/locale/hr.js");
require("moment/locale/de.js");
require("moment/locale/bs.js");
require("moment/locale/sr.js");
require("moment/locale/sl.js");

class EventGroupItem extends Component {
  lastSelectedBet = -1;

  state = {
    currentActiveBetTypeID: -1,
    currentActiveBetsInfos: [],
    currentBetInfo: null,
    customMatchesToShow: []
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    //pogledaj je li se promjenio property
    if (prevProps.currentLanguage !== this.props.currentLanguage) {
      moment.locale(this.props.currentLanguage);
      console.log("CHANGED LANG!");
    }
  }

  componentDidMount() {
    //provjeri da je odabran postojeci bettypeid

    if (this.props.allBetsText) {
      //mici i sva 1x2 reg vrijeme zasade ovako
      //170 tenis pobjednik, 172 1.set pobjednik
      //99 basket konacni pobjednik
      //430 basket broj koseva igraca
      var bets1x2 = [287, 287, 329, 336, 318, 112, 117, 170, 172, 99, 430];

      let betTypeButtons = this.props.allBetsText.filter(
        x =>
          x.SportID === this.props.currentSportID &&
          !bets1x2.includes(x.IDOkladaVrsta)
      );

      var btn = betTypeButtons.find(
        x => x.IDOkladaVrsta === this.state.currentActiveBetTypeID
      );

      if (!btn && betTypeButtons.length > 0) {
        //oznaci prvog dostupnog
        btn = betTypeButtons[0];

        let id = btn.IDOkladaVrsta;

        if (id === 11) {
          id = 3; //nogomet, umjesto zbroj golova multi odaberi oba daju gol
        }

        if (id === 423) {
          id = 177; //tenis, umjesto hendikep gemova odaberi tocan rezultat
        }

        this.setState({ currentActiveBetTypeID: id });
        let tmpDate = new Date();

        //rokni dohvat podataka

        //this.props.startLoading(true, false);
        // GetPairsForBetType(
        //   moment(this.props.chosenDate)
        //     .add(tmpDate.getTimezoneOffset(), "m")
        //     .toDate(),
        //   ConvertLanguageCodeToJezikID(this.props.currentLanguage),
        //   id,
        //   tmpDate.getTimezoneOffset(),
        //   0,
        //   this.getPairsForBetType_Callback.bind(this)
        // );

        // GetBetDetails(
        //   ConvertLanguageCodeToJezikID(this.props.currentLanguage),
        //   id,
        //   this.getBetDetails_Callback.bind(this)
        // );
      }
    }
  }

  getDoubleChanceSectionHeadermarkup = () => {
    if (
      !(
        (this.props.activeMostPlayedButtonID === MostPlayedOptionIDs.PREMATCH
          ? this.state.currentBetInfo
            ? this.state.currentBetInfo.Tipovi.length < 6
            : true
          : true) &&
        this.props.currentActionButton < 1 &&
        this.props.canShowExtraBetsPrematch &&
        this.props.prematchExtraBetsID < 1 &&
        !this.props.eventInfo.isFavoritPlus
      )
    ) {
      return null;
    }

    var markup = null;

    if (
      ConvertEmmettSportIDToBetRadarID(this.props.eventInfo.sportID) ===
        BetRadarSportIDs.SOCCER ||
      ConvertEmmettSportIDToBetRadarID(this.props.eventInfo.sportID) ===
        BetRadarSportIDs.ALL_SPORTS ||
      this.props.activeMostPlayedButtonID === MostPlayedOptionIDs.SUPERTIP
    ) {
      //nogomet
      markup = (
        <Auxx>
          <div
            className={[CssClasses.oddBox, CssClasses.withRightPadding].join(
              " "
            )}
          >
            1/2
          </div>
          <div className={CssClasses.oddBox}>
            X2<div className={CssClasses.oddBoxTitle}>Dupla šansa</div>
          </div>
          <div
            className={[
              CssClasses.oddBox,
              CssClasses.withLeftBorder,
              CssClasses.borderInTitleRow,
              CssClasses.withLeftPadding
            ].join(" ")}
          >
            1X
          </div>
        </Auxx>
      );
    } else if (
      ConvertEmmettSportIDToBetRadarID(this.props.eventInfo.sportID) ===
        BetRadarSportIDs.TENNIS &&
      this.props.activeMostPlayedButtonID !== MostPlayedOptionIDs.MOST_TIPPED
    ) {
      //tenis
      markup = (
        <Auxx>
          <div
            className={[CssClasses.oddBox, CssClasses.withRightPadding].join(
              " "
            )}
          >
            2
          </div>
          <div className={CssClasses.oddBox}>
            1<div className={CssClasses.oddBoxTitle}>1. set pobjednik</div>
          </div>
          <div
            className={[
              CssClasses.oddBox,
              CssClasses.withLeftBorder,
              CssClasses.borderInTitleRow,
              CssClasses.withLeftPadding
            ].join(" ")}
          >
            &nbsp;
          </div>
        </Auxx>
      );
    } else if (
      ConvertEmmettSportIDToBetRadarID(this.props.eventInfo.sportID) ===
        BetRadarSportIDs.BASKETBALL &&
      this.props.activeMostPlayedButtonID !== MostPlayedOptionIDs.MOST_TIPPED
    ) {
      //basket
      markup = (
        <Auxx>
          <div
            className={[CssClasses.oddBox, CssClasses.withRightPadding].join(
              " "
            )}
          >
            2
          </div>
          <div className={CssClasses.oddBox}>
            1<div className={CssClasses.oddBoxTitle}>Konačni pobjednik</div>
          </div>
          <div
            className={[
              CssClasses.oddBox,
              CssClasses.withLeftBorder,
              CssClasses.borderInTitleRow,
              CssClasses.withLeftPadding
            ].join(" ")}
          >
            &nbsp;
          </div>
        </Auxx>
      );
    }

    return markup;
  };

  render() {
    //define middle section markup
    let middleSectionHeaderMarkup = null;
    let doubleChanceSectionHeaderMarkup = this.getDoubleChanceSectionHeadermarkup();

    if (this.props.eventInfo.isFavoritPlus) {
      middleSectionHeaderMarkup = this.getFavoritPlusTitleMarkup(
        this.props.eventInfo.tipNames
      );
    } else {
      middleSectionHeaderMarkup = this.getMiddleSectionTitleMarkup(
        this.state.currentActiveBetTypeID
      );
    }

    //console.log("EVENT INFO IS ", this.props.eventInfo);

    if (this.props.eventInfo.leagueID === 21) {
      console.log("EVENT INFO IS ", this.props.eventInfo);
    }

    //alert("MPID " + this.props.activeMostPlayedButtonID);

    //define header colors
    //define header colors
    let titleRowClasses = [CssClasses.boxTitleRow];
    let headerRowClass = CssClasses.headerRowColorDefault;
    let mainRowClass = CssClasses.mainRowColorDefault;
    let altRowClass = CssClasses.alternateRowDefault;
    let btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightDefault;
    let btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveDefault;
    let leagueHeader = CssClasses.leagueHeaderDefault;

    //i dodaj boju ovisno o sportu
    switch (ConvertEmmettSportIDToBetRadarID(this.props.eventInfo.sportID)) {
      case 1: //soccer
        headerRowClass = CssClasses.headerRowColorSoccer;
        mainRowClass = CssClasses.mainRowColorSoccer;
        altRowClass = CssClasses.alternateRowSoccer;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightSoccer;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveSoccer;
        leagueHeader = CssClasses.leagueHeaderSoccer;
        break;
      case 2: //basketball
        headerRowClass = CssClasses.headerRowColorBasketball;
        mainRowClass = CssClasses.mainRowColorBasketball;
        altRowClass = CssClasses.alternateRowBasketball;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightBasketball;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveBasketball;
        leagueHeader = CssClasses.leagueHeaderBasketball;
        break;
      case 3: //baseball
        headerRowClass = CssClasses.headerRowColorBaseball;
        mainRowClass = CssClasses.mainRowColorBaseball;
        altRowClass = CssClasses.alternateRowBaseball;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightBaseball;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveBaseball;
        leagueHeader = CssClasses.leagueHeaderBaseball;
        break;
      case 4: //hockey
        headerRowClass = CssClasses.headerRowColorHockey;
        mainRowClass = CssClasses.mainRowColorHockey;
        altRowClass = CssClasses.alternateRowHockey;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightHockey;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveHockey;
        leagueHeader = CssClasses.leagueHeaderHockey;
        break;
      case 5: //tennis
        headerRowClass = CssClasses.headerRowColorTennis;
        mainRowClass = CssClasses.mainRowColorTennis;
        altRowClass = CssClasses.alternateRowTennis;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightTennis;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveTennis;
        leagueHeader = CssClasses.leagueHeaderTennis;
        break;
      case 6: //handball
        headerRowClass = CssClasses.headerRowColorHandball;
        mainRowClass = CssClasses.mainRowColorHandball;
        altRowClass = CssClasses.alternateRowHandball;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightHandball;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveHandball;
        leagueHeader = CssClasses.leagueHeaderHandball;
        break;
      case 12: //rugby
        headerRowClass = CssClasses.headerRowColorRugby;
        mainRowClass = CssClasses.mainRowColorRugby;
        altRowClass = CssClasses.alternateRowRugby;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightRugby;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveRugby;
        leagueHeader = CssClasses.leagueHeaderRugby;
        break;
      case 16: //Football
        headerRowClass = CssClasses.headerRowColorFootball;
        mainRowClass = CssClasses.mainRowColorFootball;
        altRowClass = CssClasses.alternateRowFootball;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightFootball;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveFootball;
        leagueHeader = CssClasses.leagueHeaderFootball;
        break;
      case 19: //Snooker
        headerRowClass = CssClasses.headerRowColorSnooker;
        mainRowClass = CssClasses.mainRowColorSnooker;
        altRowClass = CssClasses.alternateRowSnooker;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightSnooker;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveSnooker;
        leagueHeader = CssClasses.leagueHeaderSnooker;
        break;
      case 20: //TableTennis
        headerRowClass = CssClasses.headerRowColorTableTennis;
        mainRowClass = CssClasses.mainRowColorTableTennis;
        altRowClass = CssClasses.alternateRowTableTennis;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightTableTennis;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveTableTennis;
        leagueHeader = CssClasses.leagueHeaderTableTennis;
        break;
      case 23: //volleyball
        headerRowClass = CssClasses.headerRowColorVolleyball;
        mainRowClass = CssClasses.mainRowColorVolleyball;
        altRowClass = CssClasses.alternateRowVolleyball;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightVolleyball;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveVolleyball;
        leagueHeader = CssClasses.leagueHeaderVolleyball;
        break;
      case 29: //futsal
        headerRowClass = CssClasses.headerRowColorFutsal;
        mainRowClass = CssClasses.mainRowColorFutsal;
        altRowClass = CssClasses.alternateRowFutsal;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightFutsal;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveFutsal;
        leagueHeader = CssClasses.leagueHeaderFutsal;
        break;
      case 31: //Badminton
        headerRowClass = CssClasses.headerRowColorBadminton;
        mainRowClass = CssClasses.mainRowColorBadminton;
        altRowClass = CssClasses.alternateRowBadminton;
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightBadminton;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveBadminton;
        leagueHeader = CssClasses.leagueHeaderBadminton;
        break;
      default:
        //titleRowClasses.push(CssClasses.colorFootball);
        btnMoreBetsHighlightClass = CssClasses.btnMoreBetsHighlightDefault;
        btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveDefault;
        break;
    }

    //override
    //btnMoreBetsActiveClass = CssClasses.btnMoreBetsActiveDefault;

    //pushaj
    titleRowClasses.push(headerRowClass);

    let shouldDrawSportIconForPair =
      (this.props.activeMostPlayedButtonID ===
        MostPlayedOptionIDs.MOST_TIPPED ||
        this.props.activeMostPlayedButtonID === MostPlayedOptionIDs.SUPERTIP ||
        this.props.activeMostPlayedButtonID ===
          MostPlayedOptionIDs.FAVORIT_PLUS) &&
      this.props.currentSportID === -10; //samo ako gleda sve sportove

    //mici i sva 1x2 reg vrijeme zasade ovako
    //99 basket konacni pobjednik
    //430 basket broj koseva igraca
    var bets1x2 = [287, 287, 329, 336, 318, 112, 117, 170, 172, 99, 430];

    let betTypeButtons = [];

    if (this.props.allBetsText) {
      betTypeButtons = this.props.allBetsText.filter(
        x =>
          x.SportID === this.props.currentSportID &&
          !bets1x2.includes(x.IDOkladaVrsta)
      );
    }

    //napravi duboku kopiju
    //var matches = JSON.parse(JSON.stringify(this.props.eventInfo.matches));
    var matches = [];

    let allCustomMatches = [];

    if (this.state.customMatchesToShow) {
      //deep copy
      allCustomMatches = JSON.parse(
        JSON.stringify(this.state.customMatchesToShow)
      );
    }

    // //nakaci sve iz custom matchesa ako ima
    // matches.forEach(match => {
    //   //vidi ako postoji custom match s tim id-em
    //   var customMatches = allCustomMatches.filter(x => x.id === match.id);

    //   if (customMatches) {
    //     customMatches.forEach(customMatch => {
    //       var newBetInfos = customMatch.betInfo;

    //       //ako jos nije dodan, dodaj
    //       newBetInfos.forEach(bi => {
    //         if (match.betInfo.findIndex(x => x.id === bi.id) === -1) {
    //           //nema, dodaj
    //           match.betInfo.push(bi);
    //         }
    //       });

    //       // match.betInfo = match.betInfo.concat(customMatch.betInfo);
    //       // console.log("DODANO ", customMatch.betInfo);
    //     });
    //   }
    // });

    //console.log("MATCHESI N STATE: ", allCustomMatches.length);

    var idCtr = 1;

    if (allCustomMatches.length > 0) {
      //ima, bacaj odavde unutra
      matches = matches.concat(allCustomMatches);

      //i baci originalne kvote unutra
      matches.forEach(m => {
        var match = this.props.eventInfo.matches.find(x => x.id === m.id);

        if (match) {
          m.betInfo = m.betInfo.concat(match.betInfo);
        }
      });
    } else {
      matches = this.props.eventInfo.matches;
    }

    //podesi ide-eve
    matches.forEach(m => {
      idCtr++;
      m.rowID = idCtr;

      //dodaj i marginu u naziv ako ima
      if (m.betInfo && m.betInfo.length > 0) {
        var bet = m.betInfo.find(
          x => x.margin !== undefined && x.margin !== ""
        );

        m.margin = bet ? bet.margin : "";
      } else {
        m.margin = "";
      }
    });

    //console.log("MATCHES ARE: ", matches);

    //imamo meceve
    //sada ih jos sortiraj po potrebi
    let sortedMatches = [...matches];

    // if (this.props.currentSortType === SortTypes.SORT_TIME_DESC) {
    //   //vrijeme silazno
    //   sortedMatches.sort(function(a, b) {
    //     if (
    //       new Date(a.startTime).getTime() === new Date(b.startTime).getTime()
    //     ) {
    //       if (a.tournamentName === b.tournamentName) {
    //         return a.homeTeam > b.homeTeam ? 1 : -1;
    //       } else if (a.tournamentName > b.tournamentName) {
    //         return -1;
    //       } else {
    //         return 1;
    //       }
    //     } else if (
    //       new Date(a.startTime).getTime() > new Date(b.startTime).getTime()
    //     ) {
    //       //zamjena u odnosu na kad ima timeMatchStartDiff u generic zbog obrnute logike
    //       return -1;
    //     } else {
    //       return 1;
    //     }
    //   });
    // } else if (this.props.currentSortType === SortTypes.SORT_TIME_ASC) {
    //   //vrijeme silazno
    //   sortedMatches.sort(function(a, b) {
    //     if (
    //       new Date(a.startTime).getTime() === new Date(b.startTime).getTime()
    //     ) {
    //       if (a.tournamentName === b.tournamentName) {
    //         return a.homeTeam > b.homeTeam ? 1 : -1;
    //       } else if (a.tournamentName > b.tournamentName) {
    //         return -1;
    //       } else {
    //         return 1;
    //       }
    //     } else if (
    //       new Date(a.startTime).getTime() > new Date(b.startTime).getTime()
    //     ) {
    //       //zamjena u odnosu na kad ima timeMatchStartDiff u generic zbog obrnute logike
    //       return 1;
    //     } else {
    //       return -1;
    //     }
    //   });
    // } else if (this.props.currentSortType === SortTypes.SORT_LEAGUE_AZ) {
    //   //vrijeme silazno
    //   sortedMatches.sort(function(a, b) {
    //     if (a.tournamentName === b.tournamentName) {
    //       return a.homeTeam > b.homeTeam ? -1 : 1;
    //     } else if (a.tournamentName > b.tournamentName) {
    //       return 1;
    //     } else {
    //       return -1;
    //     }
    //   });
    // }

    //sort ide uvijek po vremenu uzlazno
    //ali samo ako nije trenutno u najtipovanijima!
    if (
      !(this.props.activeMostPlayedButtonID === MostPlayedOptionIDs.MOST_TIPPED)
    ) {
      sortedMatches.sort(function(a, b) {
        if (
          new Date(a.startTime).getTime() === new Date(b.startTime).getTime()
        ) {
          if (a.tournamentName === b.tournamentName) {
            if (a.homeTeam === b.homeTeam && a.margin !== "") {
              return parseFloat(a.margin) > parseFloat(b.margin) ? 1 : -1;
            }
            return a.homeTeam > b.homeTeam ? 1 : -1;
          } else if (a.tournamentName > b.tournamentName) {
            return -1;
          } else {
            return 1;
          }
        } else if (
          new Date(a.startTime).getTime() > new Date(b.startTime).getTime()
        ) {
          //zamjena u odnosu na kad ima timeMatchStartDiff u generic zbog obrnute logike
          return 1;
        } else {
          return -1;
        }
      });
    }

    if (this.props.eventInfo.leagueID === 21) {
      //console.log("CURRENT SORT TYPE IS: ", this.props.currentSortType);
      console.log("PROCESSED MATCHES ARE ", sortedMatches);
    }

    // console.log("BTNS ARE ", betTypeButtons);
    // console.log("MATCHES ARE ", sortedMatches);

    //obradi jos gumbe u novu listu, samo za one za koje ima bets!
    // var tmpBtns = [...betTypeButtons];
    // betTypeButtons = [];

    // tmpBtns.forEach(btn => {
    //   var id = btn.IDOkladaVrsta;

    //   //nadji u matches neku koja ima betinfo s tim id-em
    //   sortedMatches.forEach(match => {
    //     var tmpBet = match.betInfo.find(x => x.sportVrstaOkladaID === id);

    //     if (tmpBet) {
    //       betTypeButtons.push(btn);
    //       return;
    //     }
    //   });
    // });

    //console.log("PROCESSED MATCHES ARE ", sortedMatches);
    // console.log("CURRENT BET DETAILS ARE ", this.props.initialMiddleBetInfo);

    var lastDisplayedMatchID = 0;

    return (
      <div className={CssClasses.container}>
        <audio
          ref={sound => {
            this.beepHigh = sound;
          }}
        >
          <source src={beepHigh} type="audio/mpeg" />
        </audio>
        <div className={[CssClasses.boxTitle, leagueHeader].join(" ")}>
          {getRasterIcon(
            ConvertEmmettSportIDToBetRadarID(this.props.eventInfo.sportID),
            false
          )}
          <div className={CssClasses.titleText}>
            <span className={CssClasses.countryName}>
              {this.props.eventInfo.country}
            </span>
            <span> - </span>
            <span className={CssClasses.leagueName}>
              {this.props.eventInfo.league}
            </span>
          </div>
        </div>
        {this.props.activeMostPlayedButtonID ===
        MostPlayedOptionIDs.PREMATCH ? ( //prematch
          <div className={[CssClasses.boxBetTypes, leagueHeader].join(" ")}>
            {betTypeButtons.map(btnInfo => {
              return (
                <BetTypeButton
                  onButtonClicked={id => this.btnChangeBetTypeClick(id)}
                  title={btnInfo.OkladaVrsta}
                  key={btnInfo.IDOkladaVrsta}
                  id={btnInfo.IDOkladaVrsta}
                  isActive={
                    btnInfo.IDOkladaVrsta === this.state.currentActiveBetTypeID
                  }
                  sportID={ConvertEmmettSportIDToBetRadarID(
                    this.props.eventInfo.sportID
                  )} //betradarov id
                />
              );
            })}
          </div>
        ) : null}
        <div className={titleRowClasses.join(" ")}>
          &nbsp;
          {/* &nbsp; ovdje ide regularno vrijeme ili sto vec */}
          {/* last column for button +102 */}
          {this.props.activeMostPlayedButtonID ===
            MostPlayedOptionIDs.PREMATCH || true ? (
            <div
              className={[
                CssClasses.oddBox,
                CssClasses.withLeftBorder,
                CssClasses.borderInTitleRow,
                CssClasses.withLeftPadding
              ].join(" ")}
            >
              &nbsp;
            </div>
          ) : null}
          {/* middle section */}
          {middleSectionHeaderMarkup}
          {/* dupla sansa */}
          {doubleChanceSectionHeaderMarkup}
          {/* glavna oklada */}
          {!this.props.eventInfo.isFavoritPlus ? (
            <Auxx>
              {" "}
              <div
                className={[
                  CssClasses.oddBox,
                  CssClasses.withRightPadding
                ].join(" ")}
              >
                2
              </div>
              {[
                BetRadarSportIDs.ALL_SPORTS,
                BetRadarSportIDs.SOCCER,
                BetRadarSportIDs.RUGBY,
                BetRadarSportIDs.BEACH_SOCCER,
                BetRadarSportIDs.BASKETBALL
              ].includes(
                ConvertEmmettSportIDToBetRadarID(this.props.eventInfo.sportID)
              ) ||
              // this.props.activeMostPlayedButtonID ===
              //   MostPlayedOptionIDs.MOST_TIPPED ||
              this.props.activeMostPlayedButtonID ===
                MostPlayedOptionIDs.SUPERTIP ? (
                <div className={CssClasses.oddBox}>
                  X
                  <div className={CssClasses.oddBoxTitle}>
                    1-X-2 - Regularno vrijeme
                  </div>
                </div>
              ) : null}
              <div className={CssClasses.oddBox}>
                1
                {![
                  BetRadarSportIDs.ALL_SPORTS,
                  BetRadarSportIDs.SOCCER,
                  BetRadarSportIDs.RUGBY,
                  BetRadarSportIDs.BEACH_SOCCER,
                  BetRadarSportIDs.BASKETBALL
                ].includes(
                  ConvertEmmettSportIDToBetRadarID(this.props.eventInfo.sportID)
                ) &&
                // this.props.activeMostPlayedButtonID !==
                //   MostPlayedOptionIDs.MOST_TIPPED &&
                this.props.activeMostPlayedButtonID !==
                  MostPlayedOptionIDs.SUPERTIP ? (
                  <div className={CssClasses.oddBoxTitle}>Pobjednik</div>
                ) : null}
              </div>{" "}
            </Auxx>
          ) : null}
        </div>

        {sortedMatches.map(match => {
          let availableBets = match.betInfo;

          //console.log("AVAILABEL- BETS ARE: ", availableBets);

          //console.log("last match is here ", lastDisplayedMatchID);

          return (
            <div className={CssClasses.boxEventItem} key={match.rowID}>
              {lastDisplayedMatchID === match.betRadarID ? null : (
                <span
                  className={[
                    CssClasses.startTime,
                    shouldDrawSportIconForPair ? CssClasses.resetTop : ""
                  ].join(" ")}
                >
                  {this.props.activeMostPlayedButtonID > 0
                    ? moment(match.startTime)
                        .format("ddd, HH:mm")
                        .replace(".", "")
                    : moment(match.startTime).format("HH:mm")}
                </span>
              )}

              {shouldDrawSportIconForPair
                ? getRasterIcon(
                    ConvertEmmettSportIDToBetRadarID(match.sportID),
                    true
                  )
                : null}

              {lastDisplayedMatchID === match.betRadarID ? null : (
                <span
                  className={[
                    CssClasses.matchTitle,
                    shouldDrawSportIconForPair ? CssClasses.resetTop : ""
                  ].join(" ")}
                >
                  {match.homeTeam} - {match.guestTeam}
                  {/* {match.margin !== "" ? " (" + match.margin + ")" : null} */}
                  {match.isSuperTip ? (
                    <span
                      className={[
                        SiteIcons.site_icon_crown,
                        CssClasses.iconCrown
                      ].join(" ")}
                    />
                  ) : null}
                </span>
              )}

              {/* button for extra bets +102 */}

              {lastDisplayedMatchID !== match.betRadarID &&
              (this.props.activeMostPlayedButtonID ===
                MostPlayedOptionIDs.PREMATCH ||
                true) ? (
                <div
                  className={[
                    CssClasses.oddBox,
                    CssClasses.withLeftBorder,
                    CssClasses.withLeftPadding
                  ].join(" ")}
                >
                  <OddButton
                    offsetGeneric={false}
                    moreBetsClass={btnMoreBetsHighlightClass}
                    moreBetsActiveClass={btnMoreBetsActiveClass}
                    onButtonClicked={matchID =>
                      this.btnShowAdditionalBetsClick(matchID)
                    }
                    moreBetsCount={match.numberOfExtraBets}
                    matchID={match.id}
                    isMoreBets={true}
                    isActive={this.props.prematchExtraBetsID === match.id}
                  />
                </div>
              ) : (
                <div
                  className={[
                    CssClasses.oddBox,
                    CssClasses.withLeftBorder,
                    CssClasses.withLeftPadding
                  ].join(" ")}
                >
                  &nbsp;
                </div>
              )}

              {/* middle section buttons (special bets from header) */}

              {this.props.eventInfo.isFavoritPlus
                ? this.getFavoritPlusButtonMarkup(match)
                : this.getMiddleSectionOddButtonsMarkup(
                    this.state.currentActiveBetTypeID,
                    availableBets,
                    match,
                    lastDisplayedMatchID === match.betRadarID
                  )}

              {/* main (left) section buttons - double chance  */}

              {this.getMiddleSectionDoubleChanceOddButtonsMarkup(
                lastDisplayedMatchID,
                match,
                availableBets
              )}

              {/* main (left) section buttons - main bets  */}
              {!this.props.eventInfo.isFavoritPlus ? (
                <Auxx>
                  <div
                    className={[
                      CssClasses.oddBox,
                      CssClasses.withRightPadding
                    ].join(" ")}
                  >
                    {lastDisplayedMatchID === match.betRadarID ? (
                      <span>&nbsp;</span>
                    ) : (
                      <OddButton
                        onButtonClicked={(matchID, betID) =>
                          this.btnChangeBetClick(matchID, betID)
                        }
                        betInfo={availableBets.find(
                          x => x.kategorijaPonudeID === 1 && x.shortName === "2"
                        )}
                        activeBets={this.props.ticketPairInfo.map(
                          x => x.coefID
                        )}
                        offsetGeneric={false}
                        oddType={this.props.currentOddFormat}
                      />
                    )}
                  </div>
                  {[
                    BetRadarSportIDs.ALL_SPORTS,
                    BetRadarSportIDs.SOCCER,
                    BetRadarSportIDs.RUGBY,
                    BetRadarSportIDs.BEACH_SOCCER,
                    BetRadarSportIDs.BASKETBALL
                  ].includes(
                    ConvertEmmettSportIDToBetRadarID(
                      this.props.eventInfo.sportID
                    )
                  ) ||
                  this.props.activeMostPlayedButtonID ===
                    MostPlayedOptionIDs.SUPERTIP ? (
                    <div className={CssClasses.oddBox}>
                      {" "}
                      {lastDisplayedMatchID === match.betRadarID ? (
                        <span>&nbsp;</span>
                      ) : (
                        <OddButton
                          onButtonClicked={(matchID, betID) =>
                            this.btnChangeBetClick(matchID, betID)
                          }
                          betInfo={availableBets.find(
                            x =>
                              x.kategorijaPonudeID === 1 && x.shortName === "X"
                          )}
                          activeBets={this.props.ticketPairInfo.map(
                            x => x.coefID
                          )}
                          offsetGeneric={false}
                          oddType={this.props.currentOddFormat}
                        />
                      )}
                    </div>
                  ) : null}
                  <div className={CssClasses.oddBox}>
                    {" "}
                    {lastDisplayedMatchID === match.betRadarID ? (
                      <span>&nbsp;</span>
                    ) : (
                      <OddButton
                        onButtonClicked={(matchID, betID) =>
                          this.btnChangeBetClick(matchID, betID)
                        }
                        betInfo={availableBets.find(
                          x => x.kategorijaPonudeID === 1 && x.shortName === "1"
                        )}
                        activeBets={this.props.ticketPairInfo.map(
                          x => x.coefID
                        )}
                        offsetGeneric={false}
                        oddType={this.props.currentOddFormat}
                      />
                    )}
                  </div>{" "}
                </Auxx>
              ) : null}

              <div
                className={CssClasses.oddBox}
                onClick={() => {
                  //daj zvukic
                  if (this.beepMedium) {
                    //daj zvukic
                    this.beepMedium.play();
                  }

                  this.showStatistics(match.betRadarID);
                }}
              >
                {lastDisplayedMatchID === match.betRadarID ? (
                  <span>&nbsp;</span>
                ) : (
                  <span
                    className={[
                      SiteIcons.site_icon_statistics,
                      CssClasses.statsIcon
                    ].join(" ")}
                  />
                )}
              </div>

              <span style={{ display: "none" }}>
                {(lastDisplayedMatchID = match.betRadarID)}
              </span>
            </div>
          );
        })}
      </div>
    );
  }

  showStatistics = betRadarID => {
    //alert("stats for " + betRadarID);
    this.props.setMatchForStatisticsID(betRadarID);
  };

  getFavoritPlusTitleMarkup = tipNames => {
    //gurni polje unazad
    //jer se slazu od desno prema lijevo

    tipNames = reverseArray(tipNames);
    var key = 0;
    return (
      <Auxx>
        {tipNames.map((tip, index) => {
          key++;
          if (index === 0) {
            //prvi element
            return (
              <div
                key={key}
                className={[
                  CssClasses.oddBox,
                  CssClasses.withRightPadding
                ].join(" ")}
              >
                {tip.Naziv}
              </div>
            );
          }
          if (index === tipNames.length - 1) {
            //zadnji element
            return (
              <div
                key={key}
                className={[CssClasses.oddBox, CssClasses.withLeftPadding].join(
                  " "
                )}
              >
                {tip.Naziv}
              </div>
            );
          }
          //izmedju elementi
          return (
            <div key={key} className={CssClasses.oddBox}>
              {tip.Naziv}
            </div>
          );
        })}
      </Auxx>
    );
  };

  getMiddleSectionTitleMarkup = betTypeID => {
    //ako su aktivna dodatna kladjenja, nema ovog!
    if (
      this.props.liveExtraBetsID > 0 ||
      this.props.prematchExtraBetsID > 0 ||
      this.props.activeMostPlayedButtonID !== MostPlayedOptionIDs.PREMATCH ||
      this.props.currentActionButton > 0 ||
      !this.props.canShowExtraBetsPrematch ||
      !this.props.initialMiddleBetInfo
    ) {
      return null;
    }

    var tipovi = this.state.currentBetInfo
      ? this.state.currentBetInfo.Tipovi
      : this.props.initialMiddleBetInfo.Tipovi;

    //reversaj ih zbog prikaza
    tipovi = reverseArray(tipovi);

    var idxForTitle =
      tipovi.length % 2 === 0
        ? Math.floor(tipovi.length * 0.5)
        : Math.floor((tipovi.length - 1) * 0.5);
    var isEvenNumberOfTypes = tipovi.length % 2 === 0;
    var hasExtraField = tipovi.length < 3;

    return (
      <Auxx>
        {tipovi.map((tip, index) => {
          var hasTitle = index === idxForTitle;

          if (index === 0) {
            //prvi element
            return (
              <div
                key={index + 1}
                className={[
                  CssClasses.oddBox,
                  CssClasses.withRightPadding
                ].join(" ")}
              >
                {tip.Naziv}
              </div>
            );
          }
          if (index === tipovi.length - 1) {
            //zadnji element
            return (
              <div
                key={index + 1}
                className={[
                  CssClasses.oddBox,
                  !hasExtraField ? CssClasses.withLeftBorder : "",
                  !hasExtraField ? CssClasses.borderInTitleRow : "",
                  !hasExtraField ? CssClasses.withLeftPadding : ""
                ].join(" ")}
              >
                {tip.Naziv}
                {hasTitle ? (
                  <div className={CssClasses.oddBoxTitle}>
                    {this.state.currentBetInfo
                      ? this.state.currentBetInfo.NazivPrevod
                      : this.props.initialMiddleBetInfo.NazivPrevod}
                  </div>
                ) : null}
              </div>
            );
          }
          //izmedju elementi
          return (
            <div key={index + 1} className={CssClasses.oddBox}>
              {tip.Naziv}
              {hasTitle ? (
                <div
                  className={[
                    CssClasses.oddBoxTitle,
                    isEvenNumberOfTypes ? CssClasses.forEvenNumber : ""
                  ].join(" ")}
                >
                  {this.state.currentBetInfo
                    ? this.state.currentBetInfo.NazivPrevod
                    : this.props.initialMiddleBetInfo.NazivPrevod}
                </div>
              ) : null}
            </div>
          );
        })}

        {hasExtraField ? (
          <div
            className={[
              CssClasses.oddBox,
              CssClasses.withLeftBorder,
              CssClasses.borderInTitleRow,
              CssClasses.withLeftPadding
            ].join(" ")}
          >
            &nbsp;
          </div>
        ) : null}
      </Auxx>
    );
  };

  getFavoritPlusButtonMarkup = match => {
    console.log("MAKING BTNS!");

    //ako su aktivna dodatna kladjenja, nema ovog!
    if (
      this.props.prematchExtraBetsID > 0 ||
      !this.props.canShowExtraBetsPrematch
    ) {
      //return null;
    }

    var tipNames = this.props.eventInfo.tipNames;
    var availableBets = match.betInfo;

    if (!tipNames || !availableBets) {
      console.log(
        "UKNOWN TIP NAMES OR AVAILABLE BETS! ",
        tipNames,
        availableBets
      );
      return null;
    }

    //okreni tip names jer ide unazad
    tipNames = reverseArray(tipNames);

    //console.log("MATCH IS ", match);
    //console.log("AB IS ", availableBets);

    var key = 0;

    return (
      <Auxx>
        {tipNames.map((tip, index) => {
          key++;
          if (index === 0) {
            //prvi element
            return (
              <div
                className={[
                  CssClasses.oddBox,
                  CssClasses.withRightPadding
                ].join(" ")}
                key={key}
              >
                <OddButton
                  onButtonClicked={(matchID, betID) =>
                    this.btnChangeBetClick(matchID, betID)
                  }
                  betInfo={availableBets.find(
                    x =>
                      x.kategorijaPonudeID === 1 &&
                      x.shortName === tip.TipPojedinacno
                  )}
                  activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
                  offsetGeneric={false}
                  oddType={this.props.currentOddFormat}
                />
              </div>
            );
          }
          if (index === tipNames.length - 1) {
            //zadnji element
            return (
              <div className={CssClasses.oddBox} key={key}>
                <OddButton
                  onButtonClicked={(matchID, betID) =>
                    this.btnChangeBetClick(matchID, betID)
                  }
                  betInfo={availableBets.find(
                    x =>
                      x.kategorijaPonudeID === 1 &&
                      x.shortName === tip.TipPojedinacno
                  )}
                  activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
                  offsetGeneric={false}
                  oddType={this.props.currentOddFormat}
                />
              </div>
            );
          }
          //izmedju elementi
          return (
            <div className={CssClasses.oddBox} key={key}>
              <OddButton
                onButtonClicked={(matchID, betID) =>
                  this.btnChangeBetClick(matchID, betID)
                }
                betInfo={availableBets.find(
                  x =>
                    x.kategorijaPonudeID === 1 &&
                    x.shortName === tip.TipPojedinacno
                )}
                activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
                offsetGeneric={false}
                oddType={this.props.currentOddFormat}
              />
            </div>
          );
        })}
      </Auxx>
    );
  };

  getMiddleSectionDoubleChanceOddButtonsMarkup = (
    lastDisplayedMatchID,
    match,
    availableBets
  ) => {
    if (
      !(
        (this.props.activeMostPlayedButtonID === MostPlayedOptionIDs.PREMATCH
          ? this.state.currentBetInfo
            ? this.state.currentBetInfo.Tipovi.length < 6
            : true
          : true) &&
        this.props.currentActionButton < 1 &&
        this.props.canShowExtraBetsPrematch &&
        this.props.prematchExtraBetsID < 1 &&
        !this.props.eventInfo.isFavoritPlus
      )
    ) {
      return null;
    }

    var markup = "";

    if (
      ConvertEmmettSportIDToBetRadarID(this.props.eventInfo.sportID) ===
        BetRadarSportIDs.SOCCER ||
      ConvertEmmettSportIDToBetRadarID(this.props.eventInfo.sportID) ===
        BetRadarSportIDs.ALL_SPORTS ||
      this.props.activeMostPlayedButtonID === MostPlayedOptionIDs.SUPERTIP
    ) {
      //nogomet
      markup = (
        <Auxx>
          <div
            className={[CssClasses.oddBox, CssClasses.withRightPadding].join(
              " "
            )}
          >
            {lastDisplayedMatchID === match.betRadarID ? (
              <span>&nbsp;</span>
            ) : (
              <OddButton
                onButtonClicked={(matchID, betID) =>
                  this.btnChangeBetClick(matchID, betID)
                }
                betInfo={availableBets.find(
                  x => x.kategorijaPonudeID === 1 && x.shortName === "12"
                )}
                activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
                offsetGeneric={false}
                oddType={this.props.currentOddFormat}
              />
            )}
          </div>
          <div className={CssClasses.oddBox}>
            {lastDisplayedMatchID === match.betRadarID ? (
              <span>&nbsp;</span>
            ) : (
              <OddButton
                onButtonClicked={(matchID, betID) =>
                  this.btnChangeBetClick(matchID, betID)
                }
                betInfo={availableBets.find(
                  x => x.kategorijaPonudeID === 1 && x.shortName === "X2"
                )}
                activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
                offsetGeneric={false}
                oddType={this.props.currentOddFormat}
              />
            )}
          </div>
          <div
            className={[
              CssClasses.oddBox,
              CssClasses.withLeftBorder,
              CssClasses.withLeftPadding
            ].join(" ")}
          >
            {lastDisplayedMatchID === match.betRadarID ? (
              <span>&nbsp;</span>
            ) : (
              <OddButton
                onButtonClicked={(matchID, betID) =>
                  this.btnChangeBetClick(matchID, betID)
                }
                betInfo={availableBets.find(
                  x => x.kategorijaPonudeID === 1 && x.shortName === "1X"
                )}
                activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
                offsetGeneric={false}
                oddType={this.props.currentOddFormat}
              />
            )}
          </div>
        </Auxx>
      );
    }

    if (
      (ConvertEmmettSportIDToBetRadarID(this.props.eventInfo.sportID) ===
        BetRadarSportIDs.TENNIS ||
        ConvertEmmettSportIDToBetRadarID(this.props.eventInfo.sportID) ===
          BetRadarSportIDs.BASKETBALL) &&
      this.props.activeMostPlayedButtonID !== MostPlayedOptionIDs.MOST_TIPPED
    ) {
      //tenis
      markup = (
        <Auxx>
          <div
            className={[CssClasses.oddBox, CssClasses.withRightPadding].join(
              " "
            )}
          >
            {lastDisplayedMatchID === match.betRadarID ? (
              <span>&nbsp;</span>
            ) : (
              <OddButton
                onButtonClicked={(matchID, betID) =>
                  this.btnChangeBetClick(matchID, betID)
                }
                betInfo={availableBets.find(
                  x => x.kategorijaPonudeID === 1 && x.shortName === "12"
                )}
                activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
                offsetGeneric={false}
                oddType={this.props.currentOddFormat}
              />
            )}
          </div>
          <div className={CssClasses.oddBox}>
            {lastDisplayedMatchID === match.betRadarID ? (
              <span>&nbsp;</span>
            ) : (
              <OddButton
                onButtonClicked={(matchID, betID) =>
                  this.btnChangeBetClick(matchID, betID)
                }
                betInfo={availableBets.find(
                  x => x.kategorijaPonudeID === 1 && x.shortName === "X2"
                )}
                activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
                offsetGeneric={false}
                oddType={this.props.currentOddFormat}
              />
            )}
          </div>
          <div
            className={[
              CssClasses.oddBox,
              CssClasses.withLeftBorder,
              CssClasses.withLeftPadding
            ].join(" ")}
          >
            <span>&nbsp;</span>
          </div>
        </Auxx>
      );
    }

    return markup;
  };

  getMiddleSectionOddButtonsMarkup = (betTypeID, availableBets, match) => {
    //ako su aktivna dodatna kladjenja, nema ovog!
    if (
      this.props.liveExtraBetsID > 0 ||
      this.props.prematchExtraBetsID > 0 ||
      this.props.activeMostPlayedButtonID !== MostPlayedOptionIDs.PREMATCH ||
      this.props.currentActionButton > 0 ||
      !this.props.canShowExtraBetsPrematch
    ) {
      return null;
    }

    var filteredBets = availableBets.filter(
      x => x.sportVrstaOkladaID === betTypeID
    );

    var betInfo = this.state.currentBetInfo
      ? this.state.currentBetInfo
      : this.props.initialMiddleBetInfo;

    if (!betInfo) {
      return null;
    }

    var tipovi = reverseArray(betInfo.Tipovi);

    // console.log("BETTYPEID IS ", betTypeID);
    // console.log("AVBETS ", availableBets);
    // console.log("FILTROVANE ", filteredBets);
    // console.log("TIOPVIT ", tipovi);
    // console.log("MATCH IS ", match);

    //idi po tipovima i prikazuj
    var idxForTitle =
      tipovi.length % 2 === 0
        ? Math.floor(tipovi.length * 0.5)
        : Math.floor((tipovi.length - 1) * 0.5);
    var isEvenNumberOfTypes = tipovi.length % 2 === 0;
    var hasExtraField = tipovi.length < 3;
    var marginLegend = filteredBets.length > 0 ? filteredBets[0].margin : "";

    return (
      <Auxx>
        {tipovi.map((tip, index) => {
          var hasTitle = index === idxForTitle;

          if (index === 0) {
            //prvi element
            return (
              <div
                key={index + 1}
                className={[
                  CssClasses.oddBox,
                  CssClasses.withRightPadding
                ].join(" ")}
              >
                <OddButton
                  onButtonClicked={(matchID, betID) =>
                    this.btnChangeBetClick(matchID, betID)
                  }
                  betInfo={filteredBets.find(
                    x => x.shortName === tip.TipPojedinacno
                  )}
                  activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
                  offsetGeneric={false}
                  oddType={this.props.currentOddFormat}
                />
              </div>
            );
          }
          if (index === tipovi.length - 1) {
            //zadnji element
            return (
              <div
                key={index + 1}
                className={[
                  CssClasses.oddBox,
                  !hasExtraField ? CssClasses.withLeftBorder : "",
                  !hasExtraField ? CssClasses.withLeftPadding : ""
                ].join(" ")}
              >
                <OddButton
                  onButtonClicked={(matchID, betID) =>
                    this.btnChangeBetClick(matchID, betID)
                  }
                  betInfo={filteredBets.find(
                    x => x.shortName === tip.TipPojedinacno
                  )}
                  activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
                  offsetGeneric={false}
                  oddType={this.props.currentOddFormat}
                />
              </div>
            );
          }
          //izmedju elementi
          return (
            <div key={index + 1} className={CssClasses.oddBox}>
              <OddButton
                onButtonClicked={(matchID, betID) =>
                  this.btnChangeBetClick(matchID, betID)
                }
                betInfo={filteredBets.find(
                  x => x.shortName === tip.TipPojedinacno
                )}
                activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
                offsetGeneric={false}
                oddType={this.props.currentOddFormat}
              />
            </div>
          );
        })}

        {hasExtraField ? (
          <div
            className={[
              CssClasses.oddBox,
              CssClasses.withLeftBorder,
              CssClasses.withLeftPadding
            ].join(" ")}
          >
            <span className={CssClasses.oddLegend}>{marginLegend}</span>
          </div>
        ) : null}
      </Auxx>
    );
  };

  btnChangeBetTypeClick = id => {
    if (this.beepHigh) {
      this.beepHigh.play();
    }

    console.log("CBI IS ", this.props.initialMiddleBetInfo);

    this.setState({ currentActiveBetTypeID: id });

    var tmpDate = new Date();

    this.props.startLoading(true, false);

    //zatvaraj extras
    this.props.onSetPrematchExtraBetsID(-1);

    //gasi actions terminala
    this.props.setTerminalActionsActiveButton(-1);

    //nakon timeouta upali
    setTimeout(() => {
      this.props.setCanShowExtraPrematchBets(true);
      console.log("PALIM...");
    }, 1000);

    //rokni dohvat podataka
    GetPairsForBetType(
      moment(this.props.chosenDate)
        .add(tmpDate.getTimezoneOffset(), "m")
        .toDate(),
      ConvertLanguageCodeToJezikID(this.props.currentLanguage),
      id,
      -tmpDate.getTimezoneOffset(),
      0,
      this.getPairsForBetType_Callback.bind(this)
    );

    GetBetDetails(
      ConvertLanguageCodeToJezikID(this.props.currentLanguage),
      id,
      this.getBetDetails_Callback.bind(this)
    );
  };

  getPairsForBetType_Callback = (data, betTypeID) => {
    console.log("IN CALLBACK FOR getPairsForBetType_Callback WITH DATA ", data);

    this.props.stopLoading(false);

    if (!data) {
      console.log("NO DATA!");
      return;
    }

    //filtriraj za test
    var filtered = data.filter(
      x => x.TurnirID === this.props.eventInfo.leagueID
    );

    console.log("FILTROVANI SU ", filtered);

    //obradi
    let tmpDate = new Date();
    var matches = [];

    filtered.forEach(pair => {
      console.log("OBRADA ZA ", pair);

      let betInfo = [];
      let isSuperTip = false;

      //dohvati kvote
      var kvote = pair.KvotaList;
      var tmpMargin = "";

      //za svaku kvotu salji u bet info
      kvote.forEach(kv => {
        betInfo.push({
          betID: kv.IDParKvota,
          changeDirection: 0,
          id: kv.IDParKvota,
          isActive: true,
          isEnabled: true,
          isShown: true,
          kategorijaPonudeID: betTypeID,
          longName: kv.Tip,
          matchID: pair.IDPar,
          order: 0,
          shortName: kv.Tip,
          sportVrstaOkladaID: betTypeID,
          value: kv.KvotaVrijednost,
          margin: kv.Margina
        });

        tmpMargin = kv.Margina; //nebitno od koje je kad su sve iste

        if (kv.SuperTip === 1) {
          isSuperTip = true;
        }
      });

      // betInfo.forEach(bi => {
      //   console.log("BETINFO IS ", bi);
      //   console.log("PARSED DILDO IS ", parseFloat(bi.margin));
      // });

      matches.push({
        id: pair.IDPar,
        homeTeam: pair.DomacinNaziv,
        guestTeam: pair.GostNaziv,
        startTime: moment(pair.DatumUtakmice)
          .add(-tmpDate.getTimezoneOffset(), "m")
          .toDate(),
        betInfo: betInfo,
        isSuperTip: isSuperTip,
        sportID: this.props.currentSportID, //pair.SportID vraca 0, ide kemija
        betRadarID: pair.BrMatchID,
        betTypeID: this.state.currentActiveBetTypeID,
        numberOfExtraBets: pair.BrojOklada,
        margin: tmpMargin
      });
    });

    console.log("NOVE MATCHES SU ", matches);
    console.log("MATCHES U STATEU SU ", this.state.customMatchesToShow);

    console.log("IDE SORTA ALLOOO ", MostPlayedOptionIDs.MOST_TIPPED);

    //sortiraj ih
    if (
      !(this.props.activeMostPlayedButtonID === MostPlayedOptionIDs.MOST_TIPPED)
    ) {
      matches.sort(function(a, b) {
        if (
          new Date(a.startTime).getTime() === new Date(b.startTime).getTime()
        ) {
          if (a.tournamentName === b.tournamentName) {
            if (a.homeTeam === b.homeTeam && a.margin !== "") {
              return parseFloat(a.margin) > parseFloat(b.margin) ? 1 : -1;
            }
            return a.homeTeam > b.homeTeam ? 1 : -1;
          } else if (a.tournamentName > b.tournamentName) {
            return -1;
          } else {
            return 1;
          }
        } else if (
          new Date(a.startTime).getTime() > new Date(b.startTime).getTime()
        ) {
          //zamjena u odnosu na kad ima timeMatchStartDiff u generic zbog obrnute logike
          return 1;
        } else {
          return -1;
        }
      });
    }

    this.setState({ customMatchesToShow: matches });
  };

  getBetDetails_Callback(data, betTypeID) {
    console.log("IN CALLBACK FOR getBetDetails_Callback WITH DATA ", data);

    if (!data) {
      console.log("NO DATA!");
      return;
    }

    data.VrstaOkladeID = betTypeID;

    this.setState({ currentBetInfo: data });
  }

  btnShowAdditionalBetsClick = matchID => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    console.log("SHOW EXTRA bets click for MID " + matchID);

    //handle prematch
    if (this.props.prematchExtraBetsID === matchID) {
      //ugasi, klik na isti
      this.props.onSetPrematchExtraBetsID(-1);

      //nakon timeouta upali
      setTimeout(() => {
        this.props.setCanShowExtraPrematchBets(true);
        console.log("PALIM GOVNO...");
      }, 1000);
    } else {
      //promjeni
      this.props.onSetPrematchExtraBetsID(matchID);

      //gasi actions terminala
      this.props.setTerminalActionsActiveButton(-1);
      this.props.setCanShowExtraPrematchBets(false);
    }
  };

  getTicketPairs_Callback = (data, match, bet, sport) => {
    console.log("IN CALLBACK FOR getTicketPairs_Callback WITH DATA ", data);

    if (!data) {
      console.log("NO DATA!");
      return;
    }

    if (data.length === 0) {
      console.log("EMPTY DATA!");
      return;
    }

    //console.log('SPORT IS ', sport);

    var betInfo = data[0];

    let oldBetInfo = this.props.ticketPairInfo.find(x => x.coefID === bet.id);

    if (oldBetInfo) {
      //vec je odabran, radi remove
      this.props.onRemovePair(match.id);
    } else {
      //radi add
      console.log("Adding pair..");
      this.props.onAddPair({
        coefID: bet.id,
        betID: bet.betID,
        matchID: match.id,
        matchName: betInfo.Domacin + " - " + betInfo.Gost,
        betName: betInfo.OkladaVrsta,
        pick: betInfo.TipPrevod,
        odds: betInfo.Kvota,
        checked: true,
        isLive: false,
        isShown: true,
        isEnabled: true,
        isFix: false,
        currentTime: 0,
        tournamentName: match.tournamentName,
        sportName: sport.title,
        matchStart: match.startTime,
        sportID: ConvertEmmettSportIDToBetRadarID(sport.sportID)
      });
    }
  };

  btnChangeBetClick = (matchID, coefID) => {
    console.log(
      "Btn change bet click for MID " + matchID + " coefID " + coefID
    );

    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    if (matchID === 0 || coefID === 0) {
      //disabled
      return;
    }

    //prvo ukljuci i custom utakmice zbog extra bets
    let allCustomMatches = [];
    let matches = [];

    if (this.state.customMatchesToShow) {
      //deep copy
      allCustomMatches = JSON.parse(
        JSON.stringify(this.state.customMatchesToShow)
      );
    }

    if (allCustomMatches.length > 0) {
      //ima, bacaj odavde unutra
      matches = matches.concat(allCustomMatches);

      //i baci originalne kvote unutra
      matches.forEach(m => {
        var match = this.props.eventInfo.matches.find(x => x.id === m.id);

        if (match) {
          m.betInfo = m.betInfo.concat(match.betInfo);
        }
      });
    } else {
      matches = this.props.eventInfo.matches;
    }

    //nadji match
    let match = matches.find(
      x => x.id === matchID && x.betInfo.findIndex(y => y.id === coefID) !== -1
    );
    let bet = match.betInfo.find(x => x.id === coefID);
    let sport = this.props.allSports.find(x => x.sportID === match.sportID);

    if (!bet || !match || !sport) {
      console.log("SOmething is missing! B ", bet, " M ", match, " S ", sport);
      return;
    }

    if (!bet.isEnabled || !bet.isShown) {
      //disabled
      return;
    }

    //probaj dohvatiti kuracpalac
    GetTicketPairs(
      ConvertLanguageCodeToJezikID(this.props.currentLanguage),
      coefID,
      this.getTicketPairs_Callback.bind(this),
      match,
      bet,
      sport
    );
  };
}

const getRasterIcon = (sportID, isForMatch) => {
  let cssIcon = isForMatch ? CssClasses.rasterIconMatch : CssClasses.rasterIcon;

  //console.log("FOR MATCH " + isForMatch + " CSS " + cssIcon);

  switch (sportID) {
    case -10:
      return <img src={allSportsIcon} alt="" className={cssIcon} />;
    case 1:
      return <img src={soccerIcon} alt="" className={cssIcon} />;
    case 2:
      return <img src={basketballIcon} alt="" className={cssIcon} />;
    case 3:
      return <img src={baseballIcon} alt="" className={cssIcon} />;
    case 4:
      return <img src={hockeyIcon} alt="" className={cssIcon} />;
    case 5:
      return <img src={tennisIcon} alt="" className={cssIcon} />;
    case 6:
      return <img src={handballIcon} alt="" className={cssIcon} />;
    case 12:
      return <img src={rugbyIcon} alt="" className={cssIcon} />;
    case 16:
      return <img src={footballIcon} alt="" className={cssIcon} />;
    case 19:
      return <img src={snookerIcon} alt="" className={cssIcon} />;
    case 20:
      return <img src={table_tennisIcon} alt="" className={cssIcon} />;
    case 21:
      return <img src={cricketIcon} alt="" className={cssIcon} />;
    case 22:
      return <img src={dartsIcon} alt="" className={cssIcon} />;
    case 23:
      return <img src={volleyballIcon} alt="" className={cssIcon} />;
    case 29:
      return <img src={futsalIcon} alt="" className={cssIcon} />;
    case 31:
      return <img src={badmintonIcon} alt="" className={cssIcon} />;
    case 32:
      return <img src={bowlsIcon} alt="" className={cssIcon} />;
    case 34:
      return <img src={beach_volleyballIcon} alt="" className={cssIcon} />;
    case 1000:
      return <img src={liwIcon} alt="" className={cssIcon} />;
    default:
      return <img src={specialIcon} alt="" className={cssIcon} />;
  }
};

const mapStateToProps = state => {
  return {
    isAppLoading: state.rrAppState.isLoading,
    ticketPairInfo: state.rrTicket.ticketPairInfo,
    prematchExtraBetsID: state.rrNavigation.prematchExtraBetsID,
    liveExtraBetsID: state.rrNavigation.liveExtraBetsID,
    allSports: state.rrSportEvent.activePrematchSports,
    activeMostPlayedButtonID: state.rrNavigation.mostPlayedButtonID,
    currentSportID: state.rrNavigation.prematchSportID,
    currentOddFormat: state.rrAppState.oddFormatID,
    currentActionButton: state.rrNavigation.currentActionButton,
    canShowExtraBetsPrematch: state.rrNavigation.canShowExtraBetsPrematch,
    allBetsText: state.rrSportEvent.allBetsText,
    currentLanguage: state.rrAppState.currentLanguage,
    currentSortType: state.rrAppState.sortTypeID,
    chosenDate: state.rrNavigation.chosenDate
  };
};

const mapDispatchToProps = dispatch => {
  return {
    startLoading: (isTransparent, updateLocalStorage) =>
      dispatch(StoreActions.StartLoading(isTransparent, updateLocalStorage)),
    stopLoading: updateLocalStorage =>
      dispatch(StoreActions.StopLoading(updateLocalStorage)),
    onAddPair: pairInfo => dispatch(StoreActions.AddPair(pairInfo)),
    onRemovePair: matchID => dispatch(StoreActions.RemovePair(matchID)),
    onSetPrematchExtraBetsID: betsID =>
      dispatch(StoreActions.ChangeCurrentPrematchExtraBetsID(betsID)),
    onSetLiveExtraBetsID: betsID =>
      dispatch(StoreActions.ChangeCurrentLiveExtraBetsID(betsID)),
    setCanShowExtraPrematchBets: canShow =>
      dispatch(StoreActions.SetCanShowExtraPrematchBets(canShow)),
    setMatchForStatisticsID: matchID =>
      dispatch(StoreActions.SetMatchForStatisticsID(matchID)),
    setTerminalActionsActiveButton: buttonID =>
      dispatch(StoreActions.SetTerminalActionsActiveButton(buttonID))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventGroupItem);



// WEBPACK FOOTER //
// ./src/Components/EventGroupItem/EventGroupItem.js